<template>
  <panel title="Informações Fiscais">
    <div class="l-row">
      <form-group class="l-col-2@md" label="NCM">
        <input type="text" v-model="product.ncm" v-mask="'########'" placeholder="99999999" class="form-input">
      </form-group>
    </div>
    <div class="l-row">
      <form-group class="l-col-4@md" label="Origem do Produto">
        <select v-model="product.originType" class="form-select">
          <option :value="null">Selecione</option>
          <option :value="'manufacturer'">Fabricação própria</option>
          <option :value="'reseller'">Importacao Direta</option>
          <option :value="'imported'">Importado adquirido no Brasil</option>
        </select>
      </form-group>
    </div>
    <div class="l-row">
      <form-group class="l-col-4@md" label="Código Detalhe Origem">
        <input type="text" v-model="product.originDetail" class="form-input" placeholder="99" v-mask="'###'">
        <small class="form-help">Consultar o ID no seu painel do Marketplace Mercado Livre</small>
      </form-group>
    </div>
    <div class="l-row">
      <form-group class="l-col-2@md" label="Código Situação Simples Nacional">
        <input type="text" v-model="product.csosn" placeholder="9999" v-mask="'####'" class="form-input">
        <small class="form-help">deve ser fornecido apenas para Regime Simples Nacional, para Regime Normal deixar em branco</small>
      </form-group>
    </div>
    <div class="l-row">
      <form-group class="l-col-2@md" label="Código Grupo de Regra Tributária">
        <input type="text" v-model="product.taxRuleId" class="form-input" placeholder="99" v-mask="'###'">
        <small class="form-help">Consultar o ID no seu painel do Marketplace Mercado Livre (penas para Regime Normal, para Simples Nacional deixar em branco)</small>
      </form-group>
    </div>
    <div class="l-row">
      <form-group class="l-col-2@md" label="Código Especificador da Substituição Tributária">
        <input type="text" v-model="product.cest" class="form-input" v-mask="'#######'" placeholder="9999999">
      </form-group>
    </div>
    <div class="l-row">
      <form-group class="l-col-2@md" label="Ficha de Conteúdo Importação">
        <input type="text" v-mask="'########-####-####-####-############'" placeholder="99999999-9999-9999-9999-999999999999" v-model="product.fci" class="form-input">
      </form-group>
    </div>
    <div class="l-row">
      <form-group class="l-col-2@md" label="Código Exceção tributária">
        <input type="text" v-model="product.exTipi" class="form-input" placeholder="99">
      </form-group>
    </div>
    <div class="l-row">
      <form-group class="l-col-3@md" label="Código Anvisa">
        <input type="text" v-model="product.medAnvisaCode" class="form-input" placeholder="ISENTO">
        <small class="form-help">Para isenção, preencha apenas o campo ao lado, informando o motivo</small>
      </form-group>
      <form-group class="l-col-9@md" label="Motivo Isenção" :required="product.medAnvisaCode === ''">
        <input type="text" v-model="product.medExemptionReason" class="form-input" placeholder="Motivo isenção">
      </form-group>
    </div>
    <div class="l-row">
      <form-group class="l-col-2@md" label="Peso Líquido">
        <input type="text" v-mask="'####.###'" placeholder="999.999" v-model="product.netWeight" class="form-input">
      </form-group>
    </div>
    <div class="l-row">
      <form-group class="l-col-2@md" label="Peso Bruto">
        <input type="text" v-mask="'####.###'" placeholder="999.999" v-model="product.grossWeight" class="form-input">
      </form-group>
    </div>
  </panel>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import Editable from '@/components/template/Editable/Base'
  import Loader from '@/components/template/Loader'

  export default {
    data: () => ({
      loading: false
    }),
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    mounted () {
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ])
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    components: {
      Panel,
      FormGroup,
      Editable,
      Loader
    }
  }
</script>

<style lang="sass" scoped>
  .form-input,
  .form-select:not(.form-select--sm)
    height: 42px
</style>



// WEBPACK FOOTER //
// FiscalAttributes.vue?34846ad0